<template>
  <div class="w-full px-6 py-4">
    <div v-if="resourceTypes">
      <div class="flex items-center justify-between mb-6">
        <div>
          <label class="block text-sm text-gray-700 font-medium dark:text-gray-200" tabindex="0">
            <span>{{ $t('components.resource.edit.resourceTypes.title') }}</span>
          </label>
          <p class="block text-gray-600 text-sm dark:text-gray-300">
            {{ $t('components.resource.edit.resourceTypes.info') }}
          </p>
        </div>
      </div>
      <div
        v-for="resourceType in resourceTypes"
        :key="resourceType.idResourceType"
        class="w-full flex items-center justify-between mb-2 pb-2 border-b"
      >
        <p class="text-sm" :class="_resourceTypes.includes(resourceType.idResourceType) ? 'text-gray-700 dark:text-gray-200' : 'text-gray-300 dark:text-gray-600'">
          {{ resourceType.name }}
        </p>
        <toggle-field v-model="_resourceTypes" :value="resourceType.idResourceType" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ToggleField } from '@/components/fields'

interface Props {
  resource: Record<string, any>
  resourceTypes: any[]
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:resource', value: Record<string, any>): void
}>()

const _resource = computed({
  get () {
    return props.resource
  },
  set (value) {
    emit('update:resource', value)
  },
})

const _resourceTypes = computed({
  get () {
    return _resource.value?.resourceTypes
      .map(({ idResourceType }: any) => idResourceType) || []
  },
  set (value: any[]) {
    _resource.value.resourceTypes = props.resourceTypes
      .filter(({ idResourceType }: any) => value.includes(idResourceType))
  },
})
</script>
